export default __webpack_public_path__ + "ad82ef4679dbacca17e699b68b8fa141.png";